import React, { useEffect, useState } from "react";
import api from '../../api/axiosInstance';
import { Container, Row, Col, Card, Button, Form } from "react-bootstrap";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import AppNavbar from "../../components/AppNavbar";

const BlogListPublic = () => {
  const [blogs, setBlogs] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const blogsPerPage = 6;

  useEffect(() => {
    const fetchBlogs = async () => {
      const res = await api.get("/blogs");
      setBlogs(res.data);
    };
    fetchBlogs();
  }, []);

  // Filtreleme
  const filteredBlogs = blogs.filter((b) =>
    b.title.toLowerCase().includes(search.toLowerCase()) ||
    b.content.toLowerCase().includes(search.toLowerCase())
  );

  // Sayfalama hesaplama
  const indexOfLast = currentPage * blogsPerPage;
  const indexOfFirst = indexOfLast - blogsPerPage;
  const currentBlogs = filteredBlogs.slice(indexOfFirst, indexOfLast);

  const totalPages = Math.ceil(filteredBlogs.length / blogsPerPage);

  return (
    <>
      <AppNavbar />

      <section
        className="py-5"
        style={{
          marginTop: "80px",
          background: "linear-gradient(135deg, #E7F5F2 0%, #ffffff 100%)",
        }}
      >
        <Container>
          {/* HEADER */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            className="text-center mb-5"
          >
            <h2 className="fw-bold" style={{ color: "#2D8A7A" }}>
              Blog Yazıları
            </h2>
            <p className="text-muted lead">
              Bilimsel içeriklere göz atın ve majistral dünyasını keşfedin.
            </p>
          </motion.div>

          <Row className="g-4">
            {/* LEFT AREA – BLOG LIST */}
            <Col md={9}>
              <Row className="g-4">
                {currentBlogs.map((post, index) => (
                  <Col md={6} lg={4} key={post._id}>
                    <motion.div
                      initial={{ opacity: 0, y: 40 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ delay: index * 0.05, duration: 0.5 }}
                    >
                      <Card className="border-0 shadow-sm rounded-4 h-100 hover-scale">
                        <div
                          style={{
                            height: "220px",
                            overflow: "hidden",
                            borderTopLeftRadius: "18px",
                            borderTopRightRadius: "18px",
                          }}
                        >
                          <img
                            src={post.imageUrl || "/default-blog.jpg"}
                            alt={post.title}
                            className="img-fluid w-100"
                            style={{
                              height: "100%",
                              objectFit: "cover",
                              transition: "transform 0.3s ease",
                            }}
                          />
                        </div>

                        <Card.Body>
                          <h5 className="fw-bold" style={{ color: "#2D8A7A" }}>
                            {post.title}
                          </h5>

                          <p className="text-muted" style={{ minHeight: "70px" }}>
                            <span
                              dangerouslySetInnerHTML={{
                                __html: post.content.substring(0, 140) + "...",
                              }}
                            />
                          </p>

                          <Button
                            as={Link}
                            to={`/blog/${post._id}`}
                            variant="outline-primary"
                            className="rounded-pill px-4 fw-semibold"
                          >
                            Devamını Oku →
                          </Button>
                        </Card.Body>
                      </Card>
                    </motion.div>
                  </Col>
                ))}
              </Row>

              {/* PAGINATION */}
              <div className="mt-4 d-flex justify-content-center gap-2">
                <Button
                  variant="outline-primary"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(currentPage - 1)}
                >
                  ‹ Önceki
                </Button>

                <div className="px-3 py-2 fw-bold">
                  {currentPage} / {totalPages}
                </div>

                <Button
                  variant="outline-primary"
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage(currentPage + 1)}
                >
                  Sonraki ›
                </Button>
              </div>
            </Col>

            {/* RIGHT AREA – STICKY SEARCH BAR */}
            <Col md={3}>
              <div
                className="p-4 shadow-sm rounded-4"
                style={{
                  background: "#fff",
                  position: "sticky",
                  top: "100px",
                }}
              >
                <h5 className="fw-bold mb-3" style={{ color: "#2D8A7A" }}>
                  🔍 Blog Arama
                </h5>
                <Form.Control
                  type="text"
                  placeholder="Kelime ile ara..."
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    setCurrentPage(1);
                  }}
                  className="mb-3"
                />

                <p className="text-muted small">
                  Toplam <strong>{filteredBlogs.length}</strong> sonuç bulundu.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default BlogListPublic;
